import { render, staticRenderFns } from "./ModalCustomerAddresses.vue?vue&type=template&id=db1c4c36&lang=pug&"
import script from "./ModalCustomerAddresses.vue?vue&type=script&lang=js&"
export * from "./ModalCustomerAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports